import { useReadFromClipboard } from 'hooks/useReadFromClipboard';
import { useCallback } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { triggerCopyTextToClipboard, useCopyTextToClipboardHandler } from 'utils/clipboard/clipboard';

export const useBatchFormClipboard = () => {
  const workSpaceString = 'Batch Workspace';

  const copyClipboardHandler = useCopyTextToClipboardHandler();
  const copyToClipboard = useCallback(
    (value: string, key: string) => {
      if (key === 'C' || key === 'c') {
        logAnalytics.trackEvent(workSpaceString, 'Copy field (Ctrl+C)');
      }
      if (key === 'X' || key === 'x') {
        logAnalytics.trackEvent(workSpaceString, 'Copy field (Ctrl+X)');
      }
      triggerCopyTextToClipboard(copyClipboardHandler, value, false);
    },
    [copyClipboardHandler],
  );

  const clipboardReader = useReadFromClipboard();
  const readPastedContentClipboard = useCallback(async () => {
    const rawClipboardContent = await clipboardReader.readText();
    logAnalytics.trackEvent('Batch Workspace', 'Paste field (Ctrl+V)');
    if (Array.isArray(rawClipboardContent)) {
      return rawClipboardContent[0].split(/[,;]/);
    }
    return rawClipboardContent;
  }, [clipboardReader]);

  return {
    copyToClipboard,
    readPastedContentClipboard,
  };
};
